import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41df72da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "slider" }
const _hoisted_2 = { id: "slider_content" }
const _hoisted_3 = { id: "menus" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SilderItem = _resolveComponent("SilderItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$props.items, (item, index) => {
          return (_openBlock(), _createBlock(_component_SilderItem, {
            localHref: item.local?true:false,
            toPath: item.path,
            title: item.name,
            key: `silder_${index}`
          }, null, 8, ["localHref", "toPath", "title"]))
        }), 128))
      ]),
      _hoisted_4
    ])
  ]))
}